import React from "react";

interface PaginationProps {
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalItems,
  itemsPerPage,
  onPageChange,
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const handleClick = (page: number) => {
    if (page < 1 || page > totalPages) return;
    onPageChange(page);
  };
  const noOfPageShowing = 10;

  return (
    <div className="pagination">
      <button
        onClick={() => handleClick(currentPage - 1)}
        disabled={currentPage === 1}
        className="rounded-full border"
      >
        Previous
      </button>
      {Array.from({ length: totalPages }, (_, index) => {
        if (
          index + 1 >= currentPage - noOfPageShowing / 2 &&
          index + 1 <= currentPage + noOfPageShowing / 2
        ) {
          return (
            <button
              key={index + 1}
              onClick={() => handleClick(index + 1)}
              className={index + 1 === currentPage ? "active border-0" : ""}
            >
              {index + 1}
            </button>
          );
        }
      })}
      <button
        onClick={() => handleClick(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="rounded-full border "
      >
        Next
      </button>
    </div>
  );
};
